import { Injectable } from '@angular/core';
import { HttpService } from '@app/core/http/http.service';

import { FilterView } from 'app/shared/models/ipm/FilterView';
import { ConfigReportsDto } from '@app/shared/models/ipm/dto/ConfigReportsDto';

import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import * as FileSaver from 'file-saver';
import { ReportStatus, ReportView, SendReportView } from '@app/shared/views/ReportView';
import { ReportCommissionedFilterView } from '@app/shared/views/ReportCommissionedFilterView';
import { CommonFilterComboView } from '@app/shared/models/ipm/view/CommonFilterComboView';
import { FilterIPMComboDto, FilterIPMResultDto } from '@app/shared/models/ipm/dto/FilterIPMResultDto';
import {CommunicationView} from "@app/shared/models/CommunicationView";
import {TransactionsReportsDto} from "@app/shared/models/ipm/dto/TransactionsReportsDto";

@Injectable()
export class TransactionsReportsService {

  private sApiFiles = '/api/files';
  private sApiDownload = '/download';
  private sApiUpload = '/upload';

  // API endpoint to retrieve allowed file extensions for transactions file upload
  private sApiGetTransactionsFileExtensions = '/api/configuration/transactionsFileExtensions';

  private subjectGetAllFiles = new Subject<number>();
  observableGetAllFiles$ = this.subjectGetAllFiles.asObservable();

  constructor(private httpService: HttpService) { }

  public getAllFiles(customerId: number) {
    this.subjectGetAllFiles.next(customerId);
  }

  public getAll(customerId: number): Observable<Array<any>> {
    return this.httpService.get<Array<any>>(this.sApiFiles + '/' + customerId) ;
  }

  public upload(customerId: number, file: TransactionsReportsDto): Observable<any> {
    return this.httpService.post(this.sApiFiles + this.sApiUpload + '/' + customerId, file);
  }

  public download(customerId: number, fileId: number): Observable<any> {
    return this.httpService.post(this.sApiFiles + this.sApiDownload + '/' + customerId + '/' + fileId, { responseType: 'blob' });
  }

  public delete(customerId: number, fileId: number): Observable<any> {
    return this.httpService.delete<any>(this.sApiFiles + '/' + customerId + '/' + fileId) ;
  }

  // Retrieves the allowed file extensions for transactions file upload from the [cfg].[Configurations] table
  public getTransactionsFileExtensions(): Observable<string> {
    return this.httpService.get<string>(this.sApiGetTransactionsFileExtensions);
  }

}
